import React, { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';

const CookiePopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up">
      <div className="container mx-auto max-w-4xl">
        <div className="bg-dark-card border border-dark-border rounded-lg shadow-2xl p-6">
          <div className="flex items-start justify-between mb-4">
            <h3 className="text-white font-bold text-lg">Gestion des cookies</h3>
            <button
              onClick={handleReject}
              className="text-dark-muted hover:text-white transition-colors"
              aria-label="Fermer"
            >
              <FiX size={20} />
            </button>
          </div>
          <p className="text-dark-muted text-sm mb-6">
            Nous utilisons des cookies pour améliorer votre expérience, analyser le trafic
            et personnaliser le contenu. En continuant à naviguer, vous acceptez notre
            utilisation des cookies. Vous pouvez modifier vos préférences à tout moment.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={handleAccept}
              className="flex-1 bg-accent-primary hover:bg-accent-primary/90 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
            >
              Accepter tous les cookies
            </button>
            <button
              onClick={handleReject}
              className="flex-1 bg-dark-surface hover:bg-dark-border text-white font-semibold py-3 px-6 rounded-lg transition-colors border border-dark-border"
            >
              Refuser
            </button>
            <a
              href="/cookies"
              className="flex-1 text-center text-accent-primary hover:text-accent-secondary font-semibold py-3 px-6 rounded-lg transition-colors"
            >
              En savoir plus
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePopup;

